import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { useSpace } from '../../../hooks/useSpace';
import { useAuth } from '../../../hooks/useAuth';
import { keys } from './keys';

async function markAllRead(spaceId: string, userId: string) {
  const { error } = await apiClient
    .from('notifications')
    .update({ read_at: new Date().toISOString() })
    .eq('space_id', spaceId)
    .eq('user_id', userId)
    .is('read_at', null);

  if (error) {
    throw error;
  }
}

export default function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();
  const { user } = useAuth();

  return useMutation({
    mutationFn: () => markAllRead(currentSpace!.id, user!.id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.lists() });
      queryClient.invalidateQueries({ queryKey: keys.unreadCount() });
    },
  });
}
